import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { routesPath } from '@router/routes';
import { PageLoading } from '@dynamika-shared/ui/PageLoading/PageLoading';
import { useBreadcrumbs } from '@hooks/useBreadcrumbs';

export const SiteUserQueriesEntryPage = () => {
  const { id: clinicalTrialId } = useParams<{
    id: string;
  }>();
  useBreadcrumbs([['Site User Queries', 'subjectQueries']], [clinicalTrialId!]);

  const contextData = useClinicalTrialContextSlice(state => state.data);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      contextData?.configuration?.id &&
      clinicalTrialId === contextData.configuration.id
    ) {
      const _siteId = contextData?.affiliatedSiteList?.[0]?.id;
      if (_siteId) {
        navigate(`${routesPath.subjectQueriesBase}/${clinicalTrialId}/${_siteId}`);
      }
    }
  }, [contextData, clinicalTrialId]);

  return <PageLoading className='w-full h-[70vh]' />;
};
